/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandThumbDownIcon16Light = forwardRef('HandThumbDownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.736 16c.658 0 1.259-.371 1.553-.96l2.52-5.04H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H4.562a2.5 2.5 0 0 0-2.426 1.894L.981 8.514A2 2 0 0 0 2.92 11H6v3.264C6 15.223 6.777 16 7.736 16ZM11 3H4.562a1.5 1.5 0 0 0-1.456 1.136L1.951 8.757A1 1 0 0 0 2.921 10H6.5a.5.5 0 0 1 .5.5v3.764a.736.736 0 0 0 1.394.33L11 9.381V3Zm1 0v6h2V3h-2Z" })));
});
